import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DateTime } from 'luxon';

import { CoachSettingsGeneralDiplomaController } from 'presentation/page/settings/coach-settings/coach-settings-general/coach-settings-general-diploma/coach-settings-general-diploma.controller';

@Component({
	selector: 'spr-coach-settings-general-diploma-diploma',
	templateUrl: './coach-settings-general-diploma-diploma.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CoachSettingsGeneralDiplomaDiplomaComponent {
	@Input() form!: FormGroup;

	public referenceDateRange: string;
	constructor(public controller: CoachSettingsGeneralDiplomaController) {
		const referenceMaxYear = DateTime.now().year;
		const referenceMinYear = DateTime.now().minus({ years: 70 }).year;
		this.referenceDateRange = `${referenceMinYear}:${referenceMaxYear}`;
	}
}
